import { ReserveCard2 } from "../../../mobile/components/cards/ReserveCard";
import { download } from "lib/downloadTickets";
import NotificationModal from "views/mobile/components/Popup/NotificationModal";
import OfficeDesktopLayout from "views/components/OfficeDesktopLayout";
import Provider from "views/components/ReserveScreen";
import React from "reactn";
import { ReservationCard } from "views/desktop/components/ReservationCard";
import { Typography } from "antd";
import { GenericModal } from "views/mobile/components/GenericModal";
const { Title } = Typography;

const ReserveScreen = ({
	activeMeetButton,
	goToMeet,
	cancelLoading,
	reservationCofirmed,
	setOpenCancelModal,
	openCancelModal,
	line,
	reservation,
	user,
	isLoggedInTemporary,
	userId,
	setPreferences,
	setModalState,
	setCloseModal,
	push,
	never_show_popup_notifications,
	isVisibleNotificationModal,
	name,
	datetime,
	code,
	office,
	onClick,
	token,
}) => {
	const visibleButton = false;
	return (
		<>
			{!isLoggedInTemporary && (
				<>
					{isVisibleNotificationModal &&
						(!never_show_popup_notifications ||
							never_show_popup_notifications === false) &&
						(!push || push === false) && (
							<NotificationModal
								user={userId}
								onClose={setCloseModal}
								setModalState={setModalState}
								setPreferences={setPreferences}
							/>
						)}
				</>
			)}
			<OfficeDesktopLayout
				user={user}
				office={office}
				title={`${name} - Ticket de reserva`}
				reserveScreen
			>
				<GenericModal
					onClick={onClick}
					visible={openCancelModal}
					type={"reservationCancel"}
					onCancel={() => setOpenCancelModal(false)}
					loading={cancelLoading}
				/>
				<ReservationCard
					line={line}
					office={office}
					code={code}
					datetime={datetime}
					reservation={reservation}
					name={name}
					dowloadTicketAction={download}
					onClick={() => setOpenCancelModal(true)}
					reservationCofirmed={reservationCofirmed}
					goToMeet={goToMeet}
					activeMeetButton={activeMeetButton}
					token={token}
				/>
				{/* <p>{message}</p>
	<ReserveCard2
		downloadReserveAction={download}
		isVisibleButton={visibleButton}
		name={name}
		datetime={datetime}
		code={code}
		officeName={office.name}
		wait={wait}
		waiting={waiting}
		onClick={onClick}
	></ReserveCard2> */}
			</OfficeDesktopLayout>
		</>
	);
};

export default Provider(ReserveScreen);
